// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"113":"6012229f","586":"b01343fe"}[chunkId] + ".js";
};